module.exports = __webpack_public_path__ + "img/wblog-2.84bf35d0.png";